<template>
  <div>
    <div v-if="!personalInfo.personalInformation"><SystemAlert/></div>
    <div>
      <Tab/>
    </div>
  </div>
</template>
  
<script>
import appConfig from '@/app.config'
import Tab from '../../components/tabs/Tab.vue'
import { mapActions, mapGetters } from 'vuex'
import * as COMMONS from '../../store/_commons'
import SystemAlert from '@/components/SystemAlert'


export default {
  name: 'Profile',
  page: {
    title: `Profile | ${appConfig.shortName}`,
    meta: [
      {
        name: 'description',
        content: 'You can view your Personal Information, Credentials, Registrations, Adjudications, Make Reservations'
      }
    ]
  },
  data() {
    return {
      // activeModal: false,
      // activeTimer: null
    }
  },
  components: {
    Tab,
    SystemAlert
  },
  computed: {
    ...mapGetters({
      statusInfo: COMMONS.GUEST_LOGIN_STATUS_INFO,
      personalInfo: COMMONS.GUEST_PERSONAL_INFO,
    }),
  },
  methods: {
    ...mapActions({
      getPersonalProfileInformation: COMMONS.GUEST_PROFILE,
      // getRegistrationInformation: COMMONS.GUEST_REGISTRATION,
      getGuestLogout: COMMONS.GUEST_LOGIN_GET_LOGOUT,
      // getAdjudicationInformation: COMMONS.GUEST_ADJUDICATION,
    }),
    getProfile() {
      this.getPersonalProfileInformation();
    },
  },
  created() {
    this.getProfile();
    this.$store.state.guestLogin.loginUserDetails = null;
  },

  mounted() {
    // window.event.type;
    // document.addEventListener("backbutton", this.getLogout());
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = function() {
      history.go(1);
      //window.history.pushState(null, "", window.location.href);
    },

    // window.addEventListener("message", (event) => {
    //   console.log('PROFILE EVENT FOR RESERVATIONS IS ', event)
    //   if (event.origin === "https://ridmvwebtest-dev.ri.gov") {
    //     const receivedData = event.data;
    //     // Process the received data
    //     console.log('FINAL RES API DATA IS', receivedData);
    //     window.scrollTo(0,0);
    //     this.getProfile();
    //   }
    // }, false);

    window.addEventListener("message", (event) => {
      // Check the origin of the message to ensure it's from a trusted source
      if (event.origin !== "https://ridmvwebtest-dev.ri.gov") {
        console.warn('Received message from an untrusted origin:', event.origin);
        return;
      }

      // Process the message data
      const message = event.data;
      console.log('Received message:', message);

      // Example: Respond back to the sender
      // event.source.postMessage({ type: 'response', text: 'Message received!' }, event.origin);
    });
  },
}
</script>

<!-- <style lang="css">
    * {
      margin: 0;
      padding: 0;
      font-family: 'Karla', sans-serif;
    }
    .wrapper {
      width: 100%;
      min-height: 100vh;
      background-color: #f8f8f8;
      margin: 0;
      padding: 20px;
    }
    .change__style {
      background-color: #eee;
      font-size: 1em;
      margin-bottom: 10px;
      padding: 5px;
    }
  </style> -->